import type { LucideIcon } from 'lucide-react';
import {
  AlertCircle,
  Ban,
  CheckCircle2,
  Clock,
  DollarSign,
  Send,
  ShieldCheck,
  XCircle,
  CreditCard,
} from 'lucide-react';

export const NON_CANCELLABLE_STATUSES = new Set(['approved', 'paid', 'deleted']);

export const EDITABLE_STATUSES = new Set(['submitted', 'pending']);

export const BALANCE_IMPACTING_EDIT_STATUSES = new Set(['submitted', 'pending', 'approved']);

export interface StatusConfig {
  label: string;
  value: string;
  color: string;
  icon: LucideIcon;
}

export const statusConfig: StatusConfig[] = [
  {
    label: 'Submitted',
    value: 'submitted',
    color: 'bg-slate-100 text-slate-600 border-slate-200',
    icon: Send,
  },
  {
    label: 'Pending',
    value: 'pending',
    color: 'bg-amber-100 text-amber-700 border-amber-200',
    icon: Clock,
  },
  {
    label: 'Pending - Yellow Flag',
    value: 'pending_yellow',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    icon: Clock,
  },
  {
    label: 'Pending - Red Flag',
    value: 'pending_red',
    color: 'bg-red-100 text-red-700 border-red-300',
    icon: Clock,
  },
  {
    label: 'Pre-Approved',
    value: 'pre_approved',
    color: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    icon: ShieldCheck,
  },
  {
    label: 'Pending Payment',
    value: 'pending_payment',
    color: 'bg-violet-100 text-violet-700 border-violet-200',
    icon: CreditCard,
  },
  {
    label: 'Approved',
    value: 'approved',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    icon: CheckCircle2,
  },
  {
    label: 'Paid',
    value: 'paid',
    color: 'bg-blue-100 text-blue-700 border-blue-200',
    icon: DollarSign,
  },
  {
    label: 'Rejected',
    value: 'rejected',
    color: 'bg-rose-100 text-rose-700 border-rose-200',
    icon: XCircle,
  },
  {
    label: 'Deleted',
    value: 'deleted',
    color: 'bg-red-100 text-red-700 border-red-200',
    icon: Ban,
  },
  {
    label: 'Unknown',
    value: 'unknown',
    color: 'bg-gray-100 text-gray-600 border-gray-200',
    icon: AlertCircle,
  },
];
